module.exports = __webpack_public_path__ + "media/04_for-sure.8e011c65.mp3";